import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "wardrobe",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Wardrobe",
    description: "wardrobe",
    image: require("./wardrobe.svg"),
    svgIcon: require("./wardrobe.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-42, 26) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              class="cls-1"
              d="M50.08,31.66H1.81c-1,0-1.16.12-1.16,1.15V48.92q0,9.67,0,19.35a3.06,3.06,0,0,0,.32,1c.11.27.38.51.4.78.07,1,.15,1.1,1.15,1.1h46c1,0,1.09-.13,1.14-1.1a2,2,0,0,1,.29-.66,2.26,2.26,0,0,1,.29.66c.05,1,.15,1.09,1.14,1.1H97.38c1.08,0,1.18-.1,1.22-1.1,0-.22,0-.57.14-.62.67-.26.61-.81.61-1.35q0-17.58,0-35.16c0-1.25,0-1.3-1.31-1.3Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              d="M50.08,31.66H98c1.26,0,1.31.05,1.31,1.3q0,17.58,0,35.16c0,.54.06,1.09-.61,1.35-.11,0-.14.4-.14.62,0,1-.14,1.1-1.22,1.1H51.43c-1,0-1.09-.13-1.14-1.1a2.26,2.26,0,0,0-.29-.66,2,2,0,0,0-.29.66c-.05,1-.16,1.1-1.14,1.1h-46c-1,0-1.08-.12-1.15-1.1,0-.27-.29-.51-.4-.78a3.06,3.06,0,0,1-.32-1q0-9.67,0-19.35V32.81c0-1,.12-1.15,1.16-1.15ZM1.5,68.49h97V32.58H1.5Zm.75,1.78h46.6v-.81H2.25Zm48.89,0H97.75v-.79H51.14Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M1.5,68.49V32.58h97V68.49ZM92.74,52.42h.13c0-3.13,0-6.26,0-9.4a19.59,19.59,0,0,0-.15-2.15,1.57,1.57,0,0,0-1.27-1.45c-.75-.19-1.49-.39-2.22-.63-.24-.08-.56-.27-.61-.47a3.5,3.5,0,0,0-2.19-2.23,13.36,13.36,0,0,0-5.85-1.15,1.88,1.88,0,0,0-1.8.83,2,2,0,0,1-2.33,1.17,3.13,3.13,0,0,0-.53,0c-2.75,0-3,.2-3.57,2.92q-1.4,6.7-2.75,13.41c-.48,2.36-.91,4.74-1.32,7.11a1.53,1.53,0,0,0,1.21,2.06,15.89,15.89,0,0,0,2.15.59.94.94,0,0,1,.9.93c.13,1.07.46,1.35,1.56,1.42,1.36.07,2.72.1,4.08.08a19.59,19.59,0,0,1,6.33.64,5.92,5.92,0,0,0,1.81.3,1.5,1.5,0,0,0,1.14-.4,1.19,1.19,0,0,1,1.24-.53q.47,0,.93,0c2.77-.06,3.08-.34,3.11-3.11C92.76,59.05,92.74,55.73,92.74,52.42Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M2.25,70.27v-.81h46.6v.81Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M51.14,70.27v-.79H97.75v.79Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              d="M92.74,52.42c0,3.31,0,6.63,0,9.94,0,2.77-.34,3-3.11,3.11q-.47,0-.93,0a1.19,1.19,0,0,0-1.24.53,1.5,1.5,0,0,1-1.14.4,5.92,5.92,0,0,1-1.81-.3,19.59,19.59,0,0,0-6.33-.64c-1.36,0-2.72,0-4.08-.08C73,65.31,72.66,65,72.53,64a.94.94,0,0,0-.9-.93,15.89,15.89,0,0,1-2.15-.59,1.53,1.53,0,0,1-1.21-2.06c.41-2.37.84-4.75,1.32-7.11q1.35-6.71,2.75-13.41c.57-2.72.82-2.92,3.57-2.92a3.13,3.13,0,0,1,.53,0,2,2,0,0,0,2.33-1.17,1.88,1.88,0,0,1,1.8-.83,13.36,13.36,0,0,1,5.85,1.15,3.5,3.5,0,0,1,2.19,2.23c0,.2.37.39.61.47.73.24,1.47.44,2.22.63a1.57,1.57,0,0,1,1.27,1.45A19.59,19.59,0,0,1,92.86,43c0,3.14,0,6.27,0,9.4ZM79.4,64.25c2.12.49,4.14,1,6.17,1.42,1.34.29,1.58.19,1.9-1.16.73-3,1.41-6.1,2.07-9.16.85-4,1.67-7.93,2.49-11.9.1-.52.27-1.13-.29-1.49-1-.64-2.06-1.21-3.15-1.85a5.26,5.26,0,0,0-.19.56c-.47,2.08-.93,4.16-1.4,6.24-.17.77-.27.81-1,.41-.9-.52-1.79-1.06-2.77-1.64C82,51.92,80.7,58,79.4,64.25ZM69.67,55.7c-.26,1.51-.54,3.18-.82,4.85a1,1,0,0,0,.85,1.31c.65.16,1.28.36,1.93.52,1.69.41,3.39.8,5.16,1.22,1.29-6.21,2.58-12.35,3.86-18.48H76.59c.26-1.3.49-2.52.75-3.75s.53-2.43.82-3.76c-1.15,0-2.17,0-3.19,0-1.38.07-1.53.21-1.83,1.59-.54,2.45-1,4.91-1.57,7.37-.29,1.4-.58,2.8-.88,4.27l3.39.76c.4.09.69.22.59.71-.23,1-.42,2.06-.68,3.08-.15.55-.53,1.05-1.14,1C71.82,56.23,70.82,56,69.67,55.7ZM81.92,44.48c1.8-1.3,3.49-2.42,5.06-3.69a1.79,1.79,0,0,0-.13-3.11,9.81,9.81,0,0,0-6.46-1.53,1.3,1.3,0,0,0-1.25,1.25,3.1,3.1,0,0,0,.1,1.58C80.06,40.8,81,42.57,81.92,44.48Zm6.23,20.33h1.34c2.51,0,2.6-.07,2.63-2.56q.07-7.66.13-15.34c0-.22,0-.45,0-.68h-.08C90.82,52.4,89.49,58.56,88.15,64.81Zm-9.23-.72a2,2,0,0,0,.15-.29Q80.94,54.88,82.81,46c.17-.79-.48-.85-1-1s-.76.08-.88.64c-1,4.9-2,9.79-3.06,14.69-.23,1.12-.46,2.24-.69,3.39ZM88,40.56l-5.57,4.1,4.11,2.45ZM70.61,51.27c-.22,1.16-.47,2.23-.58,3.3a1.19,1.19,0,0,0,.63.9,6.58,6.58,0,0,0,2,.44,1.08,1.08,0,0,0,.87-.53c.31-1.05.5-2.13.74-3.26Zm10.88-6.83c-1-2.2-2.56-4.09-2.93-6.73L77,44.85ZM78.64,64.69l-5.51-1.26c0,.59-.06,1.2.58,1.23C75.28,64.73,76.84,64.69,78.64,64.69Zm9.58-26.15A2,2,0,0,0,87.16,37a11.35,11.35,0,0,0-6.92-1.61,1.2,1.2,0,0,0-1.21.82,4.71,4.71,0,0,1,1.36-.54,10.73,10.73,0,0,1,6.3,1.37A9,9,0,0,1,88.22,38.54ZM92,41.26l.23-.16c-.21-.3-.36-.76-.65-.87a26.66,26.66,0,0,0-2.67-.83l0,.16Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M79.4,64.25C80.7,58,82,51.92,83.28,45.68c1,.58,1.87,1.12,2.77,1.64.68.4.78.36,1-.41.47-2.08.93-4.16,1.4-6.24a5.26,5.26,0,0,1,.19-.56c1.09.64,2.14,1.21,3.15,1.85.56.36.39,1,.29,1.49-.82,4-1.64,7.94-2.49,11.9-.66,3.06-1.34,6.12-2.07,9.16-.32,1.35-.56,1.45-1.9,1.16C83.54,65.22,81.52,64.74,79.4,64.25Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M69.67,55.7c1.15.25,2.15.53,3.18.67.61.08,1-.42,1.14-1,.26-1,.45-2,.68-3.08.1-.49-.19-.62-.59-.71l-3.39-.76c.3-1.47.59-2.87.88-4.27.52-2.46,1-4.92,1.57-7.37.3-1.38.45-1.52,1.83-1.59,1,0,2,0,3.19,0-.29,1.33-.57,2.54-.82,3.76s-.49,2.45-.75,3.75h4.06c-1.28,6.13-2.57,12.27-3.86,18.48-1.77-.42-3.47-.81-5.16-1.22-.65-.16-1.28-.36-1.93-.52a1,1,0,0,1-.85-1.31C69.13,58.88,69.41,57.21,69.67,55.7Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M81.92,44.48C81,42.57,80.06,40.8,79.24,39a3.1,3.1,0,0,1-.1-1.58,1.3,1.3,0,0,1,1.25-1.25,9.81,9.81,0,0,1,6.46,1.53A1.79,1.79,0,0,1,87,40.79C85.41,42.06,83.72,43.18,81.92,44.48Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M88.15,64.81c1.34-6.25,2.67-12.41,4-18.57h.08c0,.23,0,.46,0,.68q-.06,7.68-.13,15.34c0,2.49-.12,2.56-2.63,2.56Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M78.92,64.09l-1.71-.42c.23-1.15.46-2.27.69-3.39,1-4.9,2.06-9.79,3.06-14.69.12-.56.34-.8.88-.64s1.14.21,1,1q-1.86,8.92-3.74,17.85A2,2,0,0,1,78.92,64.09Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M88,40.56l-1.46,6.55-4.11-2.45Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M70.61,51.27l3.67.85c-.24,1.13-.43,2.21-.74,3.26a1.08,1.08,0,0,1-.87.53,6.58,6.58,0,0,1-2-.44,1.19,1.19,0,0,1-.63-.9C70.14,53.5,70.39,52.43,70.61,51.27Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M81.49,44.44,77,44.85l1.54-7.14C78.93,40.35,80.46,42.24,81.49,44.44Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M78.64,64.69c-1.8,0-3.36,0-4.93,0-.64,0-.57-.64-.58-1.23Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M88.22,38.54a9,9,0,0,0-1.53-1.48,10.73,10.73,0,0,0-6.3-1.37,4.71,4.71,0,0,0-1.36.54,1.2,1.2,0,0,1,1.21-.82A11.35,11.35,0,0,1,87.16,37,2,2,0,0,1,88.22,38.54Z"
              transform="translate(-0.65 -31.66)"
            />
            <path
              class="cls-1"
              d="M92,41.26l-3.14-1.7,0-.16a26.66,26.66,0,0,1,2.67.83c.29.11.44.57.65.87Z"
              transform="translate(-0.65 -31.66)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
